import Swiper, { Pagination, Navigation, Autoplay } from 'swiper';

Swiper.use([Navigation, Pagination, Autoplay]);

const heroSliderClass = '.hero_slider';
const heroSliderElement = document.querySelector(heroSliderClass);
const getDelay =
  heroSliderElement && heroSliderElement.getAttribute('data-delay')
    ? heroSliderElement.getAttribute('data-delay')
    : 5000;

/**
 * swiperHero is an instance
 * @type {{slidesPerView : number, spaceBetween : number, autoplay : {delay : number, disableOnInteraction : boolean}, pagination : {el : string, type : string}, navigation : {nextEl : string, prevEl : string}}}
 */
const updateHeroNavButtons = (swiper) => {
  const $el = swiper.$el;
  const isFirst = swiper.activeIndex === 0;
  const isLast = swiper.isEnd;

  const prevBtn = $el.find('.hero_slider .hero_prev_button');
  const nextBtn = $el.find('.hero_slider .hero_next_button');

  if (isFirst) {
    prevBtn.removeAttr('disabled').attr('aria-disabled', true);
  } else {
    prevBtn.removeAttr('aria-disabled');
  }

  if (isLast) {
    nextBtn.removeAttr('disabled').attr('aria-disabled', true);
  } else {
    nextBtn.removeAttr('aria-disabled');
  }
};

const updateHeroBackground = (swiper) => {
  const el = swiper.el;
  const firstItem = swiper.$el[0].querySelector('.hero_wrapper .swiper-slide:first-child');
  const isGradiant = el.classList.contains('gradiant');
  const isBlack = swiper.slides[swiper.activeIndex]?.classList.contains('black');

  if (isGradiant || (firstItem && firstItem.classList.contains('black')) || isBlack) {
    swiper.$el[0].classList.remove('white-bg');
  } else {
    swiper.$el[0].classList.add('white-bg');
  }
};

const swiperHero = new Swiper(heroSliderClass, {
  slidesPerView: 1,
  spaceBetween: 10,
  autoplay: {
    delay: getDelay,
    disableOnInteraction: false,
  },
  pagination: {
    el: '.hero_pagination',
    type: 'fraction',
  },
  navigation: {
    nextEl: '.hero_next_button',
    prevEl: '.hero_prev_button',
  },
  on: {
    init() {
      if (this.$el.find('.hero_slider')) {
        updateHeroNavButtons(this);
      }

      if (window.location.href.toLowerCase().includes('catering')) {
        this.autoplay.stop();
      }

      updateHeroBackground(this);
    },
    slideChange() {
      if (this.$el.find('.hero_slider')) {
        updateHeroNavButtons(this);
      }

      updateHeroBackground(this);
    },
  },
});

const pauseButtonClass = '.paused_button';
const playButtonClass = '.play_button';
if (pauseButtonClass) {
  const pauseButtonElement = document.querySelector(pauseButtonClass);

  if (pauseButtonElement) {
    pauseButtonElement.addEventListener('click', e => {
      document.querySelector(heroSliderClass).classList.add('paused');
      pauseButtonElement.ariaDisabled = true;
      document.querySelector(playButtonClass).ariaDisabled = false;
      e.preventDefault();
      swiperHero.autoplay.stop();
    });
  }
}

if (playButtonClass) {
  const playButtonElement = document.querySelector(playButtonClass);
  if (playButtonElement) {
    playButtonElement.ariaDisabled = true;
    playButtonElement.addEventListener('click', e => {
      document.querySelector(heroSliderClass).classList.remove('paused');
      document.querySelector(pauseButtonClass).ariaDisabled = false;
      playButtonElement.ariaDisabled = true;
      e.preventDefault();
      swiperHero.autoplay.start();
    });
  }
}

const wellbeingSlider = '.wellbeing_slider';
const wellbeingPause = document.querySelector(wellbeingSlider);
if (wellbeingPause) {
  swiperHero.autoplay.stop();
}

const swiperSlide = '.hero_slider .hero_wrapper .swiper-slide';
const swiperSlideHero = document.querySelectorAll(swiperSlide);
const buttonPanel = '.hero_slider .slider_button_panel';
const buttonPanelHero = document.querySelectorAll(buttonPanel);
if (swiperSlideHero && swiperSlideHero.length < 2 && buttonPanelHero[0]) {
  buttonPanelHero[0].style.display = 'none';
  swiperHero.autoplay.stop();
}
/**
 * swiperMenu is an instance
 * @type {{slidesPerView : number, spaceBetween : number, breakpoints : {640 : {slidesPerView : number, spaceBetween : number}, 768 : {slidesPerView : number, spaceBetween : number}}, navigation : {nextEl : string, prevEl : string}}}
 */
const attachMenuSlider = function (heroSliderClass, nextButton, prevButton) {
  const swiperMenu = new Swiper(heroSliderClass, {
    slidesPerView: 2,
    spaceBetween: 14,
    breakpoints: {
      640: {
        slidesPerView: 3,
        spaceBetween: 10,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 16,
      },
    },
    navigation: {
      nextEl: nextButton,
      prevEl: prevButton,
    },
    on: {
      init() {
        if (this.$el.find('.menu_slider')) {
          if (this.activeIndex === 0) {
            this.$el.find('.menu_slider .menu_prev_button').removeAttr('disabled');
            this.$el.find('.menu_slider .menu_prev_button').attr('aria-disabled', true);
          }
          if (this.isEnd) {
            this.$el.find('.menu_slider .menu_next_button').removeAttr('disabled');
            this.$el.find('.menu_slider .menu_next_button').attr('aria-disabled', true);
          }
        }
      },
      slideChange() {
        if (this.$el.find('.menu_slider')) {
          if (this.activeIndex === 0) {
            this.$el.find('.menu_slider .menu_prev_button').removeAttr('disabled');
            this.$el.find('.menu_slider .menu_prev_button').attr('aria-disabled', true);
          } else {
            this.$el.find('.menu_slider .menu_prev_button').removeAttr('aria-disabled');
          }
          if (this.isEnd) {
            this.$el.find('.menu_slider .menu_next_button').removeAttr('disabled');
            this.$el.find('.menu_slider .menu_next_button').attr('aria-disabled', true);
          } else {
            this.$el.find('.menu_slider .menu_next_button').removeAttr('aria-disabled');
          }
        }
      },
    },
  });
};

var yearSwiper = new Swiper('.yearslides', {
  slidesPerView: 3,
  centeredSlides: true,
  breakpoints: {
    640: {
      slidesPerView: 6,
    },
    768: {
      slidesPerView: 8,
    },
  },
  navigation: {
    nextEl: '.timeline_next_button',
    prevEl: '.timeline_prev_button',
  },
});

var timelineSlider = new Swiper('.timelineSliders', {
  slidesPerView: 'auto',
  spaceBetween: 10,
  centeredSlides: true,
  breakpoints: {
    640: {
      slidesPerView: 2,
      spaceBetween: 10,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 10,
    },
  },
});

yearSwiper.params.control = timelineSlider;
timelineSlider.params.control = yearSwiper;

yearSwiper.on('slideChange', function () {
  timelineSlider.slideTo(this.activeIndex, null, false);
});
timelineSlider.on('slideChange', function () {
  yearSwiper.slideTo(this.activeIndex, null, false);
});

if (document.querySelector('.yearclick')) {
  $('.yearclick').click(function () {
    var countAtribute = $(this).attr('data-element');
    var dataMinrange = parseInt($(this).attr('min-range'));
    var dataMaxrange = parseInt($(this).attr('max-range'));
    $('.yearclick.active').removeClass('active');
    $(this).addClass('active');

    var countNUmber = dataMinrange;
    var findnumber = countNUmber + dataMaxrange;

    timelineSlider.slideTo(findnumber, null, false);
    yearSwiper.slideTo(findnumber, null, false);

    return;
  });
}

if (document.querySelector('.loading-bar-bullet')) {
  $('.loading-bar-bullet').click(function () {
    const index = $(this).attr('data-index');
    timelineSlider.slideTo(index);
    yearSwiper.slideTo(index);
    let timelineLength = $('.loading-bar-bullet').length;
    for (let i = 0; i < timelineLength; i++) {
      const ariaLabel =
        $('.loading-bar-bullet')[i] &&
        $('.loading-bar-bullet')[i].getAttribute('aria-label').split(' ')[0] + ' ' + 'not selected';
      $('.loading-bar-bullet')[i].setAttribute('aria-label', ariaLabel);
    }
    $(this).attr(
      'aria-label',
      `${$(this).text()} selected ${$(this).attr('role')} ${$(this).attr('title')}`,
    );
    return;
  });
}

if (document.querySelector('.component_inline_timelineCard .readMore')) {
  $('.component_inline_timelineCard .readMore').click(function (event) {
    $('.swiper-slide-active .component_inline_timelineCard_text').addClass('show_all');
    event.preventDefault();
    return;
  });
}

if (document.querySelector('.component_inline_timelineCard .readLess')) {
  $('.component_inline_timelineCard .readLess').click(function (event) {
    $('.swiper-slide-active .component_inline_timelineCard_text').removeClass('show_all');
    event.preventDefault();
    return;
  });
}

if (document.querySelector('.loading-bar-bullet')) {
  $('.loading-bar-bullet').keydown(function (e) {
    const keyCode = e.keyCode || e.which;
    if (keyCode == 9 && !e.shiftKey && this && this.classList.contains('swiper-slide-active')) {
      $('.swiper-slide-active .component_inline_timelineCard').attr('tabindex', '0');
      $('.swiper-slide-active .component_inline_timelineCard').focus();
      let timelineLength = $('.loading-bar-bullet').length;
      for (let i = 0; i < timelineLength; i++) {
        const ariaLabel =
          $('.loading-bar-bullet')[i] &&
          $('.loading-bar-bullet')[i].getAttribute('aria-label').split(' ')[0] +
            ' ' +
            'not selected';
        $('.loading-bar-bullet')[i].setAttribute('aria-label', ariaLabel);
      }
      $(this).attr('aria-label', `${$(this).text()} selected`);
      e.preventDefault();
      return;
    }
  });
}

if (document.querySelector('.component_inline_timelineCard')) {
  $('.component_inline_timelineCard').keydown(function (e) {
    const keyCode = e.keyCode || e.which;
    if (keyCode == 9) {
      $('.swiper-slide-active .component_inline_timelineCard').attr('tabindex', '-1');
      if (e.shiftKey) {
        $('.swiper-slide-prev.loading-bar-bullet').focus();
      } else {
        $('.swiper-slide-next.loading-bar-bullet').focus();
      }
      e.preventDefault();
      return;
    }
  });
}

function yearListSelector(index) {
  let matchRange = null;
  const yearLinks = document.querySelectorAll('.year-list .yearclick');
  yearLinks.forEach(yearLink => {
    if (yearLink.getAttribute('max-range') <= index) {
      matchRange = yearLink;
    }
  });
  const activeYearLink = document.querySelector('.yearclick.active');
  if (activeYearLink) {
    activeYearLink.classList.remove('active');
  }
  if (matchRange) {
    matchRange.classList.add('active');
  }
}

yearSwiper.on('slideChange', function () {
  timelineSlider.slideTo(this.activeIndex, null, false);

  yearListSelector(this.activeIndex);
});

// if (document.querySelector('.menu_slider')) {
//   attachMenuSlider('.menu_slider', '.menu_next_button', '.menu_prev_button');
// }

const cateringLanding = new Swiper('.catering_landing ', {
  slidesPerView: 1,
  spaceBetween: 10,
  breakpoints: {
    640: {
      slidesPerView: 3,
      spaceBetween: 10,
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
  },
  navigation: {
    nextEl: '.menu_next_button',
    prevEl: '.menu_prev_button',
  },
});

const offerPromotionSlider = new Swiper('.offers_promoslider', {
  slidesPerView: 'auto',
  spaceBetween: 10,
  breakpoints: {
    640: {
      slidesPerView: 3,
      spaceBetween: 16,
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 25,
    },
  },
  navigation: {
    nextEl: '.menu_next_button',
    prevEl: '.menu_prev_button',
  },
});

const flip = function (event) {
  var element = event.currentTarget;
  var ctaText = element.getAttribute('data-linktext');
  if (ctaText == 'viewOptionCTA') {
    var elems = document.querySelectorAll('.flip_card');
    [].forEach.call(elems, function (el) {
      el.classList.remove('flip_card');
    });
  }
  if (element.innerHTML == 'CLOSE') {
    element.parentElement.parentElement.parentElement.classList.add('close_card');
    setTimeout(function () {
      element.parentElement.parentElement.parentElement.classList.remove('close_card');
    }, 1000);
  }
  element.closest('.component_inlinecard_two_sided').classList.toggle('flip_card');
};

export {
  attachMenuSlider,
  swiperHero,
  timelineSlider,
  yearSwiper,
  cateringLanding,
  flip,
  offerPromotionSlider,
};
